import React, { ReactNode, FC } from 'react';
import { Modal } from 'antd';

import { ColoredCloseContainer, DialogTitle } from '~src/shared/dialogs/shared.sc';
import { ShadeColorKeys } from '~src/styles/theme';

interface Props {
  show: boolean;
  onHide?: () => void;
  close?: boolean;
  title?: string | ReactNode;
  children: ReactNode;
  titleKey?: string | null;
  width?: number;
  headerColor?: ShadeColorKeys;
  headerFontColor?: ShadeColorKeys;
  className?: string;
}

const Dialog: FC<Props> =
  ({ className, width, show = false, onHide, title, titleKey = null, close = false, children = null, headerColor, headerFontColor }) => (
    <ColoredCloseContainer $fontColor={headerFontColor}>
      <Modal
        open={show}
        onCancel={onHide}
        footer={null}
        width={width}
        className={className}
        closable
        title={
          (title || close) && (
            <DialogTitle $color={headerColor} $fontColor={headerFontColor}>
              {title && <span data-translation={titleKey}>{title}</span>}
            </DialogTitle>
          )
        }
        centered={true}
      >
        {children}
      </Modal>
    </ColoredCloseContainer>
  );

export default React.memo(Dialog);
